import {
    CALENDAR_CHIP_PALETTE,
    type CalendarChipBucket,
} from '@apps/web/lib/shift_calendar_palette';
import { cn } from '@apps/web/lib/utils';

// Reference pills use a lighter fill than calendar chips: same borders,
// text, and dark mode, only the light-mode background one step softer.
// `cn` (tailwind-merge) lets this bg replace the calendar palette's, so
// every other class still comes from the shared source.
const REFERENCE_LIGHT_CHIP_BG: Record<CalendarChipBucket, string> = {
    open: 'bg-[#FFC9D0]',
    outreaching: 'bg-[#DEDCFF]',
    scheduled: 'bg-[#E6ECEC]',
    pending_confirmation: 'bg-[#E6ECEC]',
    confirmed: 'bg-[#DFF7E9]',
    in_progress: 'bg-[#E6ECEC]',
    completed: 'bg-[#E6ECEC]',
    clock_issue: 'bg-[#FFCEC1]',
    attention: 'bg-[#FFCEC1]',
    cancelled: 'bg-[#D5DEDE]',
};

// A live status change recolors the chip in place; the fade keeps the
// swap from reading as a flicker.
export const TINT_TRANSITION_CLASS =
    'transition-colors duration-300 motion-reduce:transition-none';

export function chipClassForBucket(bucket: CalendarChipBucket): string {
    return cn(
        CALENDAR_CHIP_PALETTE[bucket].chipClassName,
        REFERENCE_LIGHT_CHIP_BG[bucket],
        'hover:brightness-[0.97]',
        TINT_TRANSITION_CLASS,
    );
}
